import React, { memo, useContext, useEffect, useMemo, useRef, useState } from 'react'
import root from 'react-shadow';
import clsx from 'clsx'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { faTh } from "@fortawesome/free-solid-svg-icons/faTh";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faListAlt } from "@fortawesome/free-solid-svg-icons/faListAlt";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faDownLeftAndUpRightToCenter } from "@fortawesome/free-solid-svg-icons/faDownLeftAndUpRightToCenter";
// 491040 — icones do alternador "somar x adicionar": camadas empilhadas para somar no item que ja
// existe, e um "+" em nova caixa para incluir outra linha.
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons/faSquarePlus";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faArrowRightArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft";
import { IItemOrcamento } from "../../../types/IItemOrcamento";
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'
import { IOrcamento } from 'app/types/IOrcamento';
import { IconeFA } from 'app/components/componentes-basicos/IconeFA';
import { InputMascaraDinamica } from 'app/components/inputs/InputMascaraDinamica';
import { isValid, format, parse, startOfDay } from 'date-fns';
import { Calendario } from 'app/components/calendario/Calendarios';
import { LimiteDeErroReact } from 'app/components/componentes-basicos/LimiteDeErroReact';
import { Divider } from '@mui/material';
import { TooltipMU } from 'app/components/tooltip/TooltipMU';
import globalMU from 'globalMU';

const tipografia = require("../../estilos-reutilizaveis/tipografia.module.scss").default;
const estilosDropdown = require('../../../estilos/dropdownMenu.module.scss').default
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosBarraFerramentas = require('./barraFerramentas.module.scss').default

type BarraFerramentasContextType = {
    chamadoPeloTrocarProduto?: boolean // 470882
    onBotaoIncluirReactClicado: () => void;
    //onBotaoIncluirClicado: () => void
    onBotaoEditarReactClicado: (itens: IItemOrcamento[]) => void
    onBotaoExcluirClicado: (itens: IItemOrcamento[]) => void
    onBotaoConsultarItensClicado: (itens: IItemOrcamento[]) => void;
    onCodigoOuReferenciaInformado: (codigoOuReferencia: string, somarQuantidadeProdutoRepetido: boolean) => void // 491040
    onSelecionarTodos: (checked: boolean) => void
    onSelecionarItemsPorTipoDeEntrega: (codigoTipoEntrega: "C" | "E" | "F", checked: boolean) => void
    onAlterarTipoEntrega: (tipoEntrega: "C" | "E" | "F") => void
    onAlterarDataEntregaSelecionados: (dataEntrega: Date) => void
    onRemoverDataEntregaSelecionados: () => void
    onBotaoCompararClicado: () => void
    onAlterarEntregaPosterior: () => void
    onRegistrarPerdaCotacaoReact: ( perdaTotal: boolean ) => void
    onOrdenarItens: () => void
    onAgruparPorAmbientes: () => void
    onBotaoReservaLoteClicado: () => void
    onRatearDespesas: () => void
    onCompararItensClicado: () => void
    onOfertaSeletivaClicado: () => void
    onTipoEntregaPadrao: (tipo: "T" | "C" | "E" | "F") => void // 474918

    quantidadeItens: number
    incluirProdutoPor: "CODIGO" | "REFERENCIA"
    somarQuantidadeProdutoRepetidoPadrao: boolean // 491040
    itensSelecionados: IItemOrcamento[]
    parametroUTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO: boolean // 474918
    permiteAcaoAlterarTipoEntregaNoAcoes: boolean // 474918
    dataMaximaParaPrevisaoEntrega?: { year: number, month: number, day: number }

    limparCodigoOuReferenciaFlag: string

    exibirBotaoReservaLote: boolean
    desativarBotaoReservaLote: boolean

    desativarBotaoConsultarItens: boolean

    exibirBotaoOrdenarItens: boolean

    onTrocarProduto?: () => void // PA 470882
    desativarBotaoTrocarProduto?: boolean // PA 470882

    desativarMenuAcoes: boolean

    desativarBotaoComparar: boolean

    desativarBotaoAmbientes: boolean

    exibirBotaoOfertaSeletiva: boolean

    orcamento: IOrcamento

    exibirAcaoRatearDespesasInclusas: boolean

    onToggleExibirBarraFerramentas: (exibir: boolean) => void

    exibirBarraFerramentas: boolean

    dataInicialPrevisaoEntrega: Date
}

export const BarraFerramentasContext = React.createContext<BarraFerramentasContextType>({
    onBotaoIncluirReactClicado: () => { },
    onBotaoEditarReactClicado: () => { },
    onBotaoExcluirClicado: () => { },
    onBotaoConsultarItensClicado: () => { },
    onCodigoOuReferenciaInformado: () => { },
    onSelecionarTodos: () => { },
    onSelecionarItemsPorTipoDeEntrega: () => { },
    onAlterarTipoEntrega: () => { },
    onAlterarDataEntregaSelecionados: () => { },
    onRemoverDataEntregaSelecionados: () => { },
    onBotaoCompararClicado: () => { },
    onAlterarEntregaPosterior: () => { },
    onRegistrarPerdaCotacaoReact: () => { },
    onOrdenarItens: () => { },
    onAgruparPorAmbientes: () => { },
    onBotaoReservaLoteClicado: () => { },
    onRatearDespesas: () => { },
    onCompararItensClicado: () => { },
    onOfertaSeletivaClicado: () => { },
    onTipoEntregaPadrao: () => { },
    quantidadeItens: 0,
    incluirProdutoPor: "CODIGO",
    somarQuantidadeProdutoRepetidoPadrao: false, // 491040
    itensSelecionados: [],
    parametroUTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO: false,
    permiteAcaoAlterarTipoEntregaNoAcoes: false,
    limparCodigoOuReferenciaFlag: "",
    exibirBotaoReservaLote: false,
    desativarBotaoReservaLote: false,
    desativarBotaoConsultarItens: false,
    exibirBotaoOrdenarItens: false,
    desativarMenuAcoes: false,
    desativarBotaoComparar: false,
    desativarBotaoAmbientes: false,
    exibirBotaoOfertaSeletiva: false,
    orcamento: {} as IOrcamento,
    exibirAcaoRatearDespesasInclusas: false,
    onToggleExibirBarraFerramentas: () => { },
    exibirBarraFerramentas: true,
    dataInicialPrevisaoEntrega: new Date(),
})

// 491040 — texto que ficava no label do checkbox "Somar Quantidade do Item Existente". Mantido
// palavra por palavra: e a unica explicacao do comportamento e do parametro que o governa.
// Duas formas porque os dois consumidores renderizam diferente: o `title` nativo quebra linha com
// quebra de linha literal, enquanto o TooltipMU (MUI Tooltip) recebe um nó React e precisa de <br/>.
const _LINHAS_INSERCAO_RAPIDA = [
    "Veja Parâmetro: Vendas - Inserção Rápida - Sempre adicionar quantidade ao informar o mesmo produto",
]

const TITULO_INSERCAO_RAPIDA = _LINHAS_INSERCAO_RAPIDA.join("\n")

// const TOOLTIP_INSERCAO_RAPIDA = (
//     <>
//         {_LINHAS_INSERCAO_RAPIDA.map((linha, indice) => (
//             <React.Fragment key={linha}>
//                 {indice > 0 && <br />}
//                 {linha}
//             </React.Fragment>
//         ))}
//     </>
// )

const _traduzirIncluirProdutoPorMap: Record<string, string> = {
    "CODIGO": "o código",
    "REFERENCIA": "a referência",
}

// Codigos das teclas de atalho por LETRA da barra de ferramentas (ver o useEffect
// em BarraFerramentas): [I] Incluir e [L] Excluir. Sao um EXTRA aos accessKey
// numericos nativos dos botoes ("1" Incluir, "3" Excluir), que continuam valendo
// por compatibilidade.
//
// Precisam de listener proprio porque `accessKey` aceita UM unico caractere — nao da
// para escrever `accessKey="1 i"` e ganhar os dois atalhos: o navegador escolhe so o
// primeiro token que consegue suportar.
//
// Valores em `KeyboardEvent.code` (tecla FISICA), nao em `e.key`: com Alt pressionado
// o `e.key` pode chegar como caractere composto/dead key, dependendo do layout.
const _CODIGO_TECLA_ATALHO_INCLUIR = "KeyI"
const _CODIGO_TECLA_ATALHO_EXCLUIR = "KeyL"

const BarraFerramentas = memo(() => {
    const props = useContext(BarraFerramentasContext)
    const isMounted = useRef(false)

    useEffect(() => {
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    const [desativarTodos, setDesativarTodos] = useState<boolean>(false)

    const [exibirMenuAcoes, setExibirMenuAcoes] = useState(false)

    const [exibirBarraFerramentas, setExibirBarraFerramentas] = useState(props.exibirBarraFerramentas)

    const [exibirMenuEntregaPadrao, setExibirMenuEntregaPadrao] = useState(false)

    const [selecionarItensEntregaCaixa, setSelecionarItensEntregaCaixa] = useState(false)
    const [dataEntrega, setDataEntrega] = useState<Date>(props.dataInicialPrevisaoEntrega)

    const [selecionarItensEntregaFutura, setSelecionarItensEntregaFutura] = useState(false)
    const [selecionarItensEntregaExpedicao, setSelecionarItensEntregaExpedicao] = useState(false)

    const [tipoEntregaPadrao, setTipoEntregaPadrao] = useState(props.orcamento.TipoEntregaPadrao || "T")

    const formato = 'dd/MM/yyyy'
    const referencia = startOfDay(new Date()).getDate()

    const textoEntregaPadrao = useMemo(() => {
        switch (tipoEntregaPadrao) {
            case "C": return "Caixa";
            case "E": return "Expedição";
            case "F": return "Futura";
            default: return "Entrega Padrão";
        }
    }, [tipoEntregaPadrao])

    const textoOpcaoEntregaPadrao = useMemo(() => {
        switch (tipoEntregaPadrao) {
            case "C": return "CAIXA";
            case "E": return "EXPEDIÇÃO";
            case "F": return "FUTURA";
            default: return "TODOS";
        }
    }, [tipoEntregaPadrao])

    const [codigoOuReferencia, setCodigoOuRererencia] = useState<string>(uuidv4())
    
    const [somarQuantidadeProdutoRepetido, setSomarQuantidadeProdutoRepetido] = useState(props.somarQuantidadeProdutoRepetidoPadrao) // 491040

    useEffect(() => {
        if (isMounted.current) {
            setCodigoOuRererencia("")
        }
    }, [props.limparCodigoOuReferenciaFlag])

    useEffect(() => { // 491040
        if (isMounted.current) {
            setSomarQuantidadeProdutoRepetido(props.somarQuantidadeProdutoRepetidoPadrao)
        }
    },[props.somarQuantidadeProdutoRepetidoPadrao])

    useEffect(() => {
        if (isMounted.current) {
            setTipoEntregaPadrao(props.orcamento.TipoEntregaPadrao || "T")
        }
    }, [props.orcamento.TipoEntregaPadrao])

    useEffect(() => {
        const quantidadeTotalItensPorTipoEntrega = (codigoTipoEntrega: "C" | "E" | "F") => (props.orcamento.ItensOrcamento ?? []).filter(i => i.CodigoTipoEntrega == codigoTipoEntrega).length

        const quantidadeItensSelecionadosPorTipoEntrega = (codigoTipoEntrega: "C" | "E" | "F") => (props.orcamento.ItensOrcamento ?? []).filter(i => i.CodigoTipoEntrega == codigoTipoEntrega && i.selecionado).length

        if (isMounted.current) {
            setSelecionarItensEntregaCaixa(
                quantidadeTotalItensPorTipoEntrega("C") != 0 && quantidadeTotalItensPorTipoEntrega("C") == quantidadeItensSelecionadosPorTipoEntrega("C")
            )

            setSelecionarItensEntregaFutura(
                quantidadeTotalItensPorTipoEntrega("F") != 0 && quantidadeTotalItensPorTipoEntrega("F") == quantidadeItensSelecionadosPorTipoEntrega("F")
            )

            setSelecionarItensEntregaExpedicao(
                quantidadeTotalItensPorTipoEntrega("E") != 0 && quantidadeTotalItensPorTipoEntrega("E") == quantidadeItensSelecionadosPorTipoEntrega("E")
            )
        }
    }, [props.orcamento])

    const botaoIncluirReact = useMemo(() => <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        onClick={() => props.onBotaoIncluirReactClicado()}
        disabled={desativarTodos}
        accessKey="1"
        title="Incluir - Teclas de atalho [I] ou [1]"
        id="barra-ferramentas-grid-itens__botao-incluir"
    >
        <FontAwesomeIcon
            icon={faPlusCircle}
            style={desativarTodos ? {} : { color: "green" }} />
        <span id="barra-ferramentas-grid-itens__botao-incluir__texto" className={estilosBarraFerramentas.textoBotao}><u>I</u>ncluir</span>
    </button>, [desativarTodos, props.onBotaoIncluirReactClicado])

    const botaoEditarReact = useMemo(() => <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        id="barra-ferramentas__botao-editar"
        accessKey="2"
        title="Editar - Tecla de atalho [2]"
        onClick={() => { props.onBotaoEditarReactClicado(props.itensSelecionados) }}
        disabled={props.itensSelecionados.length == 0 || desativarTodos}
    >
        <FontAwesomeIcon icon={faEdit} />
        <span id="barra-ferramentas__botao-editar__texto" className={estilosBarraFerramentas.textoBotao}>Editar</span>
    </button>, [props.itensSelecionados, desativarTodos, props.onBotaoEditarReactClicado])

    const botaoExcluirDesativado = !(props.itensSelecionados.length > 0) || desativarTodos

    const botaoExcluir = useMemo(() => <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        onClick={() => { props.onBotaoExcluirClicado(props.itensSelecionados) }}
        accessKey="3"
        title="Excluir - Teclas de atalho [L] ou [3]"
        id="barra-ferramentas__botao-excluir"
        disabled={botaoExcluirDesativado}
    >
        <FontAwesomeIcon icon={faTimesCircle}
            style={botaoExcluirDesativado ? {} : { color: "red" }} /> <span id="barra-ferramentas__botao-excluir__texto" className={estilosBarraFerramentas.textoBotao}>Exc<u>l</u>uir</span>
    </button>, [botaoExcluirDesativado, props.itensSelecionados, props.onBotaoExcluirClicado])

    // Atalhos por letra: [I] Incluir e [L] Excluir (ver os _CODIGO_TECLA_ATALHO_* no
    // topo do arquivo para o motivo de nao dar para usar so o atributo accessKey).
    //
    // Cada atalho repete as condicoes do proprio botao: os dois so sao renderizados
    // quando o orcamento NAO e somente leitura (ver o JSX no fim deste arquivo) e cada
    // um tem seu proprio `disabled` — o accessKey nativo tambem nao dispara em botao
    // desabilitado, entao o atalho por letra tem de se comportar igual.
    useEffect(() => {
        const atalhos = [
            {
                codigo: _CODIGO_TECLA_ATALHO_INCLUIR,
                desativado: desativarTodos || props.orcamento.SomenteLeitura,
                executar: () => props.onBotaoIncluirReactClicado(),
            },
            {
                codigo: _CODIGO_TECLA_ATALHO_EXCLUIR,
                desativado: botaoExcluirDesativado || props.orcamento.SomenteLeitura,
                executar: () => props.onBotaoExcluirClicado(props.itensSelecionados),
            },
        ]

        const executarAtalhoPorLetra = (e: KeyboardEvent) => {
            // NAO checa e.shiftKey de proposito: o modificador do accessKey muda por
            // navegador (Chrome/Edge no Windows = Alt+tecla, Firefox no Windows =
            // Alt+Shift+tecla), e ignorando o Shift as duas combinacoes acionam o botao
            // nos dois navegadores — o atalho por letra fica igual ao numerico nativo.
            //
            // !e.ctrlKey exclui o AltGr (no Windows AltGr = Ctrl+Alt), usado no ABNT2
            // para digitar caractere. Efeito colateral aceito: Ctrl+Alt+tecla, que e o
            // modificador de accessKey no macOS/Linux, nao dispara o atalho por letra
            // nesses sistemas (o accessKey numerico nativo continua funcionando la).
            //
            // !e.repeat evita disparo em rajada se a tecla ficar pressionada.
            if (!e.altKey || e.ctrlKey || e.metaKey || e.repeat) return

            const atalho = atalhos.find(a => a.codigo === e.code)

            if (!atalho || atalho.desativado) return

            e.preventDefault()
            atalho.executar()
        }

        document.addEventListener("keydown", executarAtalhoPorLetra)
        return () => document.removeEventListener("keydown", executarAtalhoPorLetra)
    }, [
        desativarTodos,
        botaoExcluirDesativado,
        props.orcamento.SomenteLeitura,
        props.itensSelecionados,
        props.onBotaoIncluirReactClicado,
        props.onBotaoExcluirClicado,
    ])


    const incluirPorCodigoOuReferencia = useMemo(() => <div
        id="BarraFerramentas_GrupoInsercaoRapida"
        className={estilosBarraFerramentas.grupoInsercaoRapida}
    >
        <input id="grid-itens__barra-ferramentas__input-referencia"
            className={estilosBarraFerramentas.campoInsercaoRapida}
            onChange={e => setCodigoOuRererencia((e.target as any).value)}
            placeholder={`Informe ${_traduzirIncluirProdutoPorMap[props.incluirProdutoPor]}`}
            title="Inserção rápida do produto no orçamento - Tecla de atalho [,]&#013;Veja Parâmetro: Vendas - Inserção Rápida - Sempre adicionar quantidade ao informar o mesmo produto"
            accessKey=","
            autoComplete="off"
            autoFocus
            list="autocompleteOff" //  --- para naos mostrar dados digitados anteriormente
            value={(codigoOuReferencia) ?? ""}
            maxLength={props.incluirProdutoPor === "CODIGO" ? 5 : undefined}
            onPaste={e => {
                e.preventDefault()
                let data = e.clipboardData.getData('text')
                data = data.trimStart()

                data = data.replace(/[\t\n\r]/g, '')

                setCodigoOuRererencia(data)
            }}
            onKeyDown={e => {
                if (R.includes(e.code, ["Enter", "NumpadEnter"]) && codigoOuReferencia?.trimEnd() != '') {
                    let codproduto = codigoOuReferencia
                    setCodigoOuRererencia('')
                    props.onCodigoOuReferenciaInformado(codproduto, somarQuantidadeProdutoRepetido)
                }
            }} />

        <button className={clsx(estilosBotoes.botaoPrimario, estilosBarraFerramentas.botaoAdicionarInsercaoRapida, 'no-global-button')}
            id="grid-itens__barra-ferramenta__botao-adicionar"
            title="Adicionar o produto no orçamento"
            // Só habilita com algo digitado no campo de código/referência. Usa `trim()` pela mesma
            // razão do `onClick` logo abaixo, que já ignorava entrada só com espaços: sem isso o
            // botão ficaria habilitado com a barra de espaço e o clique não faria nada.
            disabled={(codigoOuReferencia ?? '').trim() === ''}
            onClick={() => {
                if (codigoOuReferencia?.trimEnd() != '') {
                    let codproduto = codigoOuReferencia
                    setCodigoOuRererencia('')
                    props.onCodigoOuReferenciaInformado(codproduto, somarQuantidadeProdutoRepetido)
                }
            }
            }>
            Adicionar
        </button>

        {/* 491040 — era um checkbox "Somar Quantidade do Item Existente", que exigia interpretar
            marcado/desmarcado. Virou um alternador com as duas opcoes visiveis e seus icones, de
            modo que a acao de cada estado fica explicita. O id do elemento de "somar" foi mantido
            (mesmo com "checkbox" no nome) porque automacoes externas a este repositorio podem
            depender dele. */}
        <div className={estilosBarraFerramentas.alternadorInsercao}
            role="group"
            id="BarraFerramentas__GrupoAlternador-somar-adicionar"
        >
            <button type="button"
                id="grid-itens__barra-ferramentas__checkbox-somar-quantidade"
                className={clsx(estilosBarraFerramentas.alternadorInsercaoOpcao, somarQuantidadeProdutoRepetido && estilosBarraFerramentas.alternadorInsercaoOpcaoAtiva, 'no-global-button')}
                aria-pressed={somarQuantidadeProdutoRepetido}
                title={`Somar a quantidade no item que já existe no grid \n\n${TITULO_INSERCAO_RAPIDA}`}
                onClick={() => setSomarQuantidadeProdutoRepetido(true)}
            >
                <FontAwesomeIcon icon={faLayerGroup} />
                <span id="grid-itens__barra-ferramentas__checkbox-somar-quantidade__texto" className={estilosBarraFerramentas.textoBotao}>Somar</span>
            </button>

            <button type="button"
                id="grid-itens__barra-ferramentas__botao-adicionar-nova-linha"
                className={clsx(estilosBarraFerramentas.alternadorInsercaoOpcao, !somarQuantidadeProdutoRepetido && estilosBarraFerramentas.alternadorInsercaoOpcaoAtiva, 'no-global-button')}
                aria-pressed={!somarQuantidadeProdutoRepetido}
                title={`Incluir uma nova linha para o mesmo produto \n\n${TITULO_INSERCAO_RAPIDA}`}
                onClick={() => setSomarQuantidadeProdutoRepetido(false)}
            >
                <FontAwesomeIcon icon={faSquarePlus} />
                <span id="grid-itens__barra-ferramentas__botao-adicionar-nova-linha__texto" className={estilosBarraFerramentas.textoBotao}>Adicionar</span>
            </button>
        </div>
    </div>, [codigoOuReferencia, props.incluirProdutoPor, props.onCodigoOuReferenciaInformado, somarQuantidadeProdutoRepetido])

    const botaoDropdownEntregaPadrao = useMemo(() =>
    (props.parametroUTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO // 474918
        && !desativarTodos && !props.orcamento.SomenteLeitura
        && <div className={estilosDropdown.dropdown}
            id="barra-ferramentas__dropdown-tipo-entrega-padrao"
            title="Veja parâmetros:&#0013;-Utilizar tipo de entrega padrão no orçamento&#0013;-Tipo de entrega Orçamento&#0013;-Tipos de entrega permitidos na filial"
        >
            <div className={clsx(estilosDropdown.parentL1)}>
                <TooltipMU
                    title={<>Tipo Entrega Padrão: <strong>{textoOpcaoEntregaPadrao}</strong></>}
                    id="barra-ferramentas__tooltip-tipo-entrega-padrao"
                >
                    <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                        onClick={() => setExibirMenuEntregaPadrao(!exibirMenuEntregaPadrao)}
                        disabled={desativarTodos}
                        id="barra-ferramentas__botao-tipo-entrega-padrao"
                        style={{ width: '130px', justifyContent: 'space-between' }}
                    >
                        <span id="barra-ferramentas__botao-tipo-entrega-padrao__texto" className={estilosBarraFerramentas.textoBotao}>{textoEntregaPadrao}</span>
                        <FontAwesomeIcon icon={faCaretDown} className="_ml-2" />
                    </button>
                </TooltipMU>

                {exibirMenuEntregaPadrao &&
                    <ul className={clsx(estilosDropdown.childL1, "_border-2 _border-white")} style={{ minWidth: '150px' }}
                        id="barra-ferramentas__menu-entrega-padrao"
                        onMouseLeave={() => setExibirMenuEntregaPadrao(false)}
                    >
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-entrega-padrao__todos"
                            onClick={() => {
                                setExibirMenuEntregaPadrao(false);
                                setTipoEntregaPadrao("T");
                                props.onTipoEntregaPadrao("T")
                            }}>
                            Todos
                        </li>
                        <Divider />
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-entrega-padrao__caixa"
                            onClick={() => {
                                setExibirMenuEntregaPadrao(false);
                                setTipoEntregaPadrao("C");
                                props.onTipoEntregaPadrao("C")
                            }}>
                            Caixa
                        </li>
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-entrega-padrao__expedicao"
                            onClick={() => {
                                setExibirMenuEntregaPadrao(false);
                                setTipoEntregaPadrao("E");
                                props.onTipoEntregaPadrao("E")
                            }}>
                            Expedição
                        </li>
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-entrega-padrao__futura"
                            onClick={() => {
                                setExibirMenuEntregaPadrao(false);
                                setTipoEntregaPadrao("F");
                                props.onTipoEntregaPadrao("F")
                            }}>
                            Futura
                        </li>
                    </ul>
                }
            </div>
        </div>
    ), [
        props.parametroUTILIZAR_TIPO_ENTREGA_PADRAO_ORCAMENTO,
        desativarTodos,
        props.orcamento.SomenteLeitura,
        exibirMenuEntregaPadrao,
        textoOpcaoEntregaPadrao,
        textoEntregaPadrao,
        props.onTipoEntregaPadrao
    ]);


    const desabilitarPerdaCotacaoParcial = useMemo(() =>
        props.itensSelecionados.length != 1 || props.itensSelecionados[0]?.Codigo?.startsWith("T") === true
        , [props.itensSelecionados]) // 470698
    
    const desabilitarPerdaCotacaoTotal = useMemo(() =>
        props.itensSelecionados.length > 0 && props.orcamento && props.orcamento.ItensOrcamento?.length > 0
        && props.orcamento.ItensOrcamento?.filter(i => !i.Codigo?.startsWith("T")).length <= 0
        , [props.itensSelecionados]) // 470698

    const orcamentoPossuiClienteSelecionado = useMemo(() =>
        props.orcamento && props.orcamento.CodigoCliente && props.orcamento.CodigoCliente > 7
        , [props.orcamento?.CodigoCliente]) // 470698

    const menuAcoes = useMemo(() => <ul className={estilosDropdown.dropdown} >
        <li className={clsx(estilosDropdown.parentL1)}>
            <button
                id="barra-ferramentas__botao-acoes"
                disabled={props.desativarMenuAcoes}
                className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                onClick={() => setExibirMenuAcoes(true)}
                title="Ações"
            >
                <FontAwesomeIcon icon={faClipboard} />
                <span id="barra-ferramentas__botao-acoes__texto" className={estilosBarraFerramentas.textoBotao}>Ações</span>
            </button>

            {/* 493860: qualquer opção deste menu faz `setExibirMenuAcoes(false)`, desmontando a
                <ul> inteira — inclusive o <Calendario> de "Alterar Previsão Entrega", cuja lib
                (react-modern-calendar-datepicker) estoura na limpeza do próprio useEffect
                (`ref.current` já nulo). O React propaga esse erro para o limite de erro mais
                próximo que NÃO está sendo removido; sem este limite AQUI, o limite atingido é o
                da raiz e a tela de itens inteira some. Este fica montado (só o filho sai), então
                captura o erro do desmonte e volta a renderizar no tick seguinte, sem efeito
                visível. */}
            <LimiteDeErroReact recuperarAutomaticamente>
            {exibirMenuAcoes && !props.desativarMenuAcoes &&
                <ul className={clsx(estilosDropdown.childL1, "_border-2 _border-white")} style={{ minWidth: '200px' }}
                >
                    <li className={clsx(estilosDropdown.parentL2, estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                        id="barra-ferramentas__menu-acoes__alterar-previsao-entrega"
                        title="Veja parâmetros: &#0013;-Número máximo de dias para a previsão de entrega&#0013;-Número máximo de dias para a previsão de entrega de encomenda"
                    >
                        Alterar Previsão Entrega
                        <ul className={clsx(estilosDropdown.childL2, "_border-2 _border-white")} style={{ padding: "5px" }}>
                            <li className="_mb-4 _mt-4"
                                id="barra-ferramentas__menu-acoes__alterar-previsao-entrega__data-entrega"
                            >
                                <InputMascaraDinamica
                                    valor={format(dataEntrega, formato)}
                                    id="barra-ferramentas__menu-acoes__alterar-previsao-entrega__input-data-entrega"
                                    habilitaEventoChange={true}
                                    onValorModificado={(valor) => {
                                        if (isMounted.current && isValid(parse(valor, formato, referencia))) {
                                            setDataEntrega(parse(valor, formato, referencia))
                                        }
                                    }}
                                    mascaras={['99/99/9999']}
                                    selecionarTudo={true} />
                                {dataEntrega && dataEntrega.getFullYear() < 2076 && // calendario nao aceita datas maiores que 2076, provavelmente por causa do limite do componente de calendário  
                                    <root.div>
                                        <Calendario
                                            data={dataEntrega}
                                            dataMinima={{ year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }}
                                            dataMaxima={props.dataMaximaParaPrevisaoEntrega}
                                            onDataModificado={(data) => isMounted.current && setDataEntrega(data)}
                                        />
                                    </root.div>
                                }
                                <button className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')}
                                    id="barra-ferramentas__menu-acoes__alterar-previsao-entrega__botao-ok"
                                    onClick={() => {
                                        setExibirMenuAcoes(false)
                                        props.onAlterarDataEntregaSelecionados(dataEntrega)
                                    }}>
                                    OK
                                </button>
                            </li>
                            <li><Divider></Divider></li>
                            <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                                title="Remove data de entrega dos itens selecionados"
                                id="barra-ferramentas__menu-acoes__alterar-previsao-entrega__remover-datas"
                                onClick={() => {
                                    setExibirMenuAcoes(false)
                                    props.onRemoverDataEntregaSelecionados()
                                }}>
                                Remover Datas
                            </li>
                        </ul>
                    </li>

                    {props.permiteAcaoAlterarTipoEntregaNoAcoes && // 474918 nao pode deixar mudar por aqui
                        <li
                            className={clsx(estilosDropdown.parentL2, estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)}
                            style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-acoes__alterar-tipo-entrega"
                        >
                            Alterar Tipo Entrega
                            <ul className={clsx(estilosDropdown.childL2, estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)}>
                                <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                                    id="barra-ferramentas__menu-acoes__alterar-tipo-entrega__caixa"
                                    onClick={() => {
                                        setExibirMenuAcoes(false)
                                        props.onAlterarTipoEntrega("C")
                                    }}>Caixa</li>
                                <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                                    id="barra-ferramentas__menu-acoes__alterar-tipo-entrega__expedicao"
                                    onClick={() => {
                                        setExibirMenuAcoes(false)
                                        props.onAlterarTipoEntrega("E")
                                    }}>Expedição</li>
                                <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                                    id="barra-ferramentas__menu-acoes__alterar-tipo-entrega__futura"
                                    onClick={() => {
                                        setExibirMenuAcoes(false)
                                        props.onAlterarTipoEntrega("F")
                                    }}>Futura</li>
                            </ul>
                        </li>
                    }

                    <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                        id="barra-ferramentas__menu-acoes__alterar-entrega-posterior"
                        onClick={() => {
                            setExibirMenuAcoes(false)
                            props.onAlterarEntregaPosterior()
                        }}>Alterar Entrega Posterior</li>

                    {props.exibirBotaoOfertaSeletiva &&
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            id="barra-ferramentas__menu-acoes__oferta-seletiva"
                            title="Veja parâmetro: Oferta seletiva"
                            onClick={() => {
                                setExibirMenuAcoes(false)
                                props.onOfertaSeletivaClicado()
                            }}>Oferta Seletiva</li>}


                    {props.exibirAcaoRatearDespesasInclusas &&
                        <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)} style={{ cursor: 'pointer' }}
                            title="Veja parâmetro: Exibir outras despesas nos itens do orçamento"
                            id="barra-ferramentas__menu-acoes__ratear-despesas"
                            onClick={() => {
                                setExibirMenuAcoes(false)
                                props.onRatearDespesas()
                            }}
                        >Ratear Despesas</li>}
                    <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)}
                        style={desabilitarPerdaCotacaoParcial
                            ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" }
                            : { cursor: 'pointer' }}
                        id="barra-ferramentas__menu-acoes__registrar-perda-cotacao"
                        title="Registra cotação quando apenas 1 item estiver selecionado (um a um)"
                        aria-disabled={desabilitarPerdaCotacaoParcial} // 470698
                        onClick={() => {
                            if (!orcamentoPossuiClienteSelecionado) {
                                globalMU.showErrorMessage("Cliente não informado.</br>Impossível registrar cotação perdida")
                                return
                            }
                            if (!desabilitarPerdaCotacaoParcial) {
                                setExibirMenuAcoes(false)
                                props.onRegistrarPerdaCotacaoReact(false) // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá
                            }
                        }}>Registrar Perda Cotação (Parcial)</li>
                    <li className={clsx(estilosBotoes.botaoIcone, estilosBotoes.sombraBotao)}
                        style={desabilitarPerdaCotacaoTotal
                            ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" }
                            : { cursor: 'pointer' }}
                        id="barra-ferramentas__menu-acoes__registrar-perda-cotacao_Total"
                        title="Registra cotação para todos os itens do pedido, mesmo se nem todos os itens estiverem selecionados"
                        aria-disabled={desabilitarPerdaCotacaoTotal} // 470698
                        onClick={() => { // 470698
                            if (!orcamentoPossuiClienteSelecionado) {
                                globalMU.showErrorMessage("Cliente não informado.</br>Impossível registrar cotação perdida")
                                return
                            }
                            setExibirMenuAcoes(false)

                            props.onRegistrarPerdaCotacaoReact(true)  // atenção no editar itens, se o parametro ACEITAR_PRODUTO_SEM_ESTOQUE != S é possivel gerar cotacao perdida por lá
                        }}>Registrar Perda Cotação Total do Pedido</li>
                </ul>}
            </LimiteDeErroReact>
        </li>
    </ul>, [
        props.desativarMenuAcoes,
        exibirMenuAcoes,
        props.exibirAcaoRatearDespesasInclusas,
        props.onRatearDespesas,
        props.itensSelecionados,
        desabilitarPerdaCotacaoParcial,
        props.onRegistrarPerdaCotacaoReact,
        props.exibirBotaoOfertaSeletiva,
        props.onOfertaSeletivaClicado,
        props.onAlterarEntregaPosterior,
        props.permiteAcaoAlterarTipoEntregaNoAcoes,
        props.onAlterarTipoEntrega,
        dataEntrega,
        referencia,
        props.dataMaximaParaPrevisaoEntrega,
        props.onAlterarDataEntregaSelecionados,
        props.onRemoverDataEntregaSelecionados
    ])


    const botaoAmbientes = useMemo(() => <button
        className={clsx(estilosBotoes.botaoIcone, 'no-global-button')} id="grid-itens__barra-ferramentas__botao-ambientes"
        title="Ambientes"
        onClick={() => props.onAgruparPorAmbientes()} disabled={desativarTodos || props.desativarBotaoAmbientes}>
        <FontAwesomeIcon icon={faTh} />
        <span id="grid-itens__barra-ferramentas__botao-ambientes__texto" className={estilosBarraFerramentas.textoBotao}>Ambientes</span>
    </button>, [desativarTodos, props.desativarBotaoAmbientes, props.onAgruparPorAmbientes])



    const botaoReservarLotes = useMemo(() => <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        title="Reserva / Lote"
        onClick={() => props.onBotaoReservaLoteClicado()}
        disabled={props.desativarBotaoReservaLote || desativarTodos}>
        <FontAwesomeIcon
            style={{
                color: props.desativarBotaoReservaLote || desativarTodos ? undefined : "#5ac93c"
            }}
            icon={faClipboardList} />
        <span id="grid-itens__barra-ferramentas__botao-reserva-lote__texto" className={estilosBarraFerramentas.textoBotao}>Reserva / Lote</span>
    </button>, [props.desativarBotaoReservaLote, desativarTodos, props.onBotaoReservaLoteClicado])

    const botaoConsultarItens = useMemo(() => 
    <button 
        className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        id="BarraFerramentas_botaoConsultarItens"
        title="Consultar Itens"
        onClick={() => {
            props.onBotaoConsultarItensClicado(props.orcamento.ItensOrcamento)
        }}
        disabled={props.desativarBotaoConsultarItens || desativarTodos}>
        <FontAwesomeIcon icon={faSearch} />
        <span id="grid-itens__barra-ferramentas__botao-consultar-itens__texto" className={estilosBarraFerramentas.textoBotao}>Consultar Itens</span>
    </button>, [props.orcamento.ItensOrcamento, props.onBotaoConsultarItensClicado, props.desativarBotaoConsultarItens, desativarTodos])


    const botaoComparar = useMemo(() => <button
        className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentas.botaoComparar, 'no-global-button')}
        title="Comparar"
        id="BarraGerramentas_BotaoComparar"
        disabled={props.desativarBotaoComparar}
        onClick={() => props.onCompararItensClicado()}
    >
        <span id="BarraGerramentas_BotaoComparar__texto" className={estilosBarraFerramentas.textoBotao}>Comparar</span>
    </button>, [props.desativarBotaoComparar, props.onCompararItensClicado])



    const botaoOrdenarItensDesativado = props.orcamento.SomenteLeitura || props.quantidadeItens <= 1

    const botaoOrdenarItens = useMemo(() => <button
        className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        id="BarraFerramentas_botaoOrdenarItens"
        title="Ordenar Itens"
        disabled={botaoOrdenarItensDesativado}
        onClick={() => {
            props.onOrdenarItens()
            setDesativarTodos(desativarTodos_ => !desativarTodos_)
        }}>
        <FontAwesomeIcon icon={faListAlt} />
        <span id="BarraFerramentas_botaoOrdenarItens__texto" className={estilosBarraFerramentas.textoBotao}>Ordenar Itens</span>
    </button>, [botaoOrdenarItensDesativado, props.onOrdenarItens])

    const botaoSubstituirItem = useMemo(() =>
        <button
            className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
            title="Troca o produto da linha selecionada"
            id="barra-ferramentas__botao-trocarProduto"
            disabled={props.desativarBotaoTrocarProduto}
            onClick={() => props.onTrocarProduto()}
        >
            <FontAwesomeIcon
                icon={faArrowRightArrowLeft}
                id="BarraFerramentas_IconeTrocarProduto"
            />
            <span id="barra-ferramentas__botao-trocarProduto__texto" className={estilosBarraFerramentas.textoBotao}>Trocar Produto</span>
        </button>, [props.desativarBotaoTrocarProduto, props.onTrocarProduto])

    const checkboxSelecionarTodos = useMemo(() => <div className="_flex _flex-row _items-center">
        <input
            id="barra-ferramentas__checkbox-selecionar-todos"
            type='checkbox'
            title='Seleciona/deseleciona todos os itens do orçamento - Tecla de atalho [0]'
            accessKey="0"
            //checked={props.itensSelecionados.length == props.quantidadeItens && props.quantidadeItens > 0}
            ref={input => {
                if (input) {
                    input.checked = props.itensSelecionados.length == props.quantidadeItens && props.quantidadeItens > 0
                    input.indeterminate = props.itensSelecionados.length > 0 && props.itensSelecionados.length != props.quantidadeItens;
                }
            }}
            onChange={(e) => {
                props.onSelecionarTodos(e.target.checked)
            }}
        />

        <ul className={estilosDropdown.dropdown}>
            <li className={estilosDropdown.parentL1}>
                <span>
                    <FontAwesomeIcon icon={faCaretDown} />
                </span>

                <ul className={clsx(estilosDropdown.childL1, "_border-2 _border-white")}>
                    <li >
                        <span>
                            <input
                                type="checkbox"
                                checked={selecionarItensEntregaCaixa}
                                id="barra-ferramentas__checkbox-selecionar-todos__Caixa"
                                onChange={(e) => {
                                    props.onSelecionarItemsPorTipoDeEntrega("C", e.target.checked)
                                    setSelecionarItensEntregaCaixa(e.target.checked)
                                }} />
                            Caixa
                        </span>
                    </li>
                    <li >
                        <span>
                            <input
                                type="checkbox"
                                checked={selecionarItensEntregaExpedicao}
                                id="barra-ferramentas__checkbox-selecionar-todos__expedicao"
                                onChange={(e) => {
                                    props.onSelecionarItemsPorTipoDeEntrega("E", e.target.checked)
                                    setSelecionarItensEntregaExpedicao(e.target.checked)
                                }} />
                            Expedição
                        </span>
                    </li>
                    <li >
                        <span >
                            <input
                                type="checkbox"
                                checked={selecionarItensEntregaFutura}
                                id="barra-ferramentas__checkbox-selecionar-todos__Futura"
                                onChange={(e) => {
                                    props.onSelecionarItemsPorTipoDeEntrega("F", e.target.checked)
                                    setSelecionarItensEntregaFutura(e.target.checked)
                                }} />
                            Futura
                        </span>
                    </li>
                </ul>
            </li>
        </ul>
    </div>, [
        props.itensSelecionados,
        props.quantidadeItens,
        props.onSelecionarTodos,
        selecionarItensEntregaCaixa,
        selecionarItensEntregaExpedicao,
        selecionarItensEntregaFutura,
        props.onSelecionarItemsPorTipoDeEntrega
    ])

    const quantidadeItensSubordinados = useMemo(
        () => (props.orcamento.ItensOrcamento ?? []).filter(i => i.Classe == "Itempedidovendasubordinado").length,
        [props.orcamento.ItensOrcamento]
    )

    const totalItens = useMemo(
        () => (props.orcamento.ItensOrcamento ?? []).length - quantidadeItensSubordinados,
        [props.orcamento.ItensOrcamento, quantidadeItensSubordinados]
    )

    const quantidadeItensSubordinadosSelecionados = useMemo(
        () => (props.orcamento.ItensOrcamento ?? []).filter(i => i.Classe == "Itempedidovendasubordinado" && i.selecionado == true).length,
        [props.orcamento.ItensOrcamento]
    )

    return <div className={estilosBarraFerramentas.barraFerramentas}>
        <div id="BarraFerramentas_OcultarMostrarBarraFerramentas" title="Oculta/Mostra botões">
            <IconeFA icone={exibirBarraFerramentas ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter}
                onClick={() => {
                    setExibirBarraFerramentas(exibir_ => !exibir_)
                    props.onToggleExibirBarraFerramentas(!exibirBarraFerramentas)
                }} />
        </div>

        {exibirBarraFerramentas && <>
            {!props.orcamento.SomenteLeitura && <div className="_flex _flex-wrap _gap-x-8 " id="BarraFerramentas_BarradDosBotoes_1">
                {/* {botaoIncluir} */}

                {botaoIncluirReact}

                {/* {botaoEditar} */}

                {botaoEditarReact}

                {botaoExcluir}

                <div className="_flex _items-center"> {/* 491040 centraliza input, botao e checkbox na mesma linha */}
                    {incluirPorCodigoOuReferencia}
                </div>

            </div>}

            <div className="_flex _flex-wrap _gap-x-8 _mt-4" id="BarraFerramentas_BarradDosBotoes_2">

                {!props.orcamento.SomenteLeitura && <>{menuAcoes}</>}
                {props.orcamento.SomenteLeitura && <>{botaoEditarReact}</>}
                {botaoAmbientes}


                {props.exibirBotaoReservaLote && botaoReservarLotes}

                {botaoConsultarItens}

                {botaoComparar}


                {props.exibirBotaoOrdenarItens && !props.orcamento.SomenteLeitura
                    && botaoOrdenarItens}

                {false && !props.orcamento.SomenteLeitura && botaoSubstituirItem} 

                {botaoDropdownEntregaPadrao}
            </div>


            {/*               
            <div className="_flex _flex-row _gap-x-8 _text-sm">
                <span className={tipografia.dicaUsuario}>
                    Mantenha a tecla SHIFT pressionada para rolar na horizontal
                </span>

                <span className={tipografia.dicaUsuario}>
                    Segure CTRL e use as setas de direção para movimentar pelo grid
                </span>
            </div> 
            */}

            <div className="_flex _flex-row _gap-x-1 _mt-4"
                style={{ alignItems: 'baseline', cursor: 'default' }}
                id="BarraFerramentas_SelecionarTodos"
            >
                {checkboxSelecionarTodos}

                {`Selecionado(s) ${props.itensSelecionados.length - quantidadeItensSubordinadosSelecionados} de ${totalItens} `}
            </div>
        </>}
    </div>


})

export {
    BarraFerramentas,
    BarraFerramentasContextType
}
